<div *ngIf="isLoading">
  <app-loader></app-loader>
</div>
<div class="container mx-auto px-4 md:px-8 py-12 mt-16 max-w-4xl">
  <div class="text-center mb-12 sm:mb-16 relative">
    <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-800">
      PRIVACY POLICY
    </h2>
    <div
      class="w-16 sm:w-20 h-1 bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] mx-auto mt-2 rounded-full"
    ></div>
  </div>

  <div
    class="privacy-content text-gray-700 leading-relaxed text-justify"
    [innerHTML]="privacyPolicy"
  ></div>
</div>
